import React, { useState } from 'react';
import StudentCard from '../../../../shared/components/StudentCard/StudentCard';
import { StudentDrawer } from '../../../../shared/components/StudentDrawer/StudentDrawer';
import s from './styles/CardsGrid.module.scss';

const CardsGrid = ({ students }) => {
  const [selectedStudent, setSelectedStudent] = useState(null);
  console.log('students grid');
  
  return (
    <section id="cardGrid" className={s.grid}>
      {students.map((student, index) => (
        <StudentCard
          key={index}
          onClick={() => setSelectedStudent(student)}
          student={student}
        />
      ))}

      <StudentDrawer
        student={selectedStudent}
        onClose={() => setSelectedStudent(null)}
      />
    </section>
  );
};

export default CardsGrid;
